/** @format */

import { ApplicationRef, enableProdMode } from '@angular/core';

import { ProductAppModule } from './app/app.module';
import { chain } from '@core/chain';
import { enableDebugTools } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { startHoneycomb } from '@shared/ssr-core/data-access';

if (environment.production) {
	enableProdMode();
}

// Is Honeycomb enabled for the current chain?
if (environment.killSwitch.honeycombEnabled[chain.chainIdentifierAbbr]) {
	// Initialize Honeycomb
	startHoneycomb(
		environment.thirdParty.honeycomb.apiKey,
		environment.thirdParty.honeycomb.serviceName
	);
}

document.addEventListener('DOMContentLoaded', () => {
	platformBrowserDynamic()
		.bootstrapModule(ProductAppModule)
		.then((module) => {
			if (!environment.production) {
				const applicationRef = module.injector.get(ApplicationRef);
				const appComponent = applicationRef.components[0];
				enableDebugTools(appComponent);
			}
		})
		.then(() => {
			if (
				'serviceWorker' in navigator &&
				environment.production &&
				environment.killSwitch.serviceWorker[chain.chainIdentifierAbbr]
			) {
				navigator.serviceWorker.register(`./ngsw-worker.js`);
			}
		})
		.catch((error) =>
			console.error(
				`APPLICATION_ERROR:BOOTSTRAP_ERROR: ${JSON.stringify(error, ['message', 'arguments', 'type', 'name'])}`
			)
		);
});
